(function () {
    angular.module('GorillaBoy.services')
    .factory('SessionManager', [
        '$window',
        'localStorageService',
        'AppConstants',
        SessionManager
    ]);

    function SessionManager($window, localStorageService, AppConstants) {
        var sessionManager = {},
            lastVisited = [],

            viewTypes = AppConstants.ViewTypes,
            galleryTypes = AppConstants.GalleryTypes,

            KEYS = {
                deletedItems: 'deletedItems',
                lastDocumentType: 'lastDocumentType',
                lastSearched: 'lastSearched',
                lastVisited: 'lastVisited',
                path: 'path',
                photoUploadUrlExpiration: 'photoUploadUrlExpiration',
                preferredSortOrderInGalleryView: 'preferredSortOrderForGalleryFileView',
                preferredSortOrderInListView: 'preferredSortOrderForListFileView',
                preferredView: 'preferredView',
                redirectState: 'redirectState',
                region: 'region',
                restoredModal: 'restoredModal',
                returningMobileVisitor: 'returningMobileVisitor',
                timeZoneId: 'timeZoneId',
                uploadFolderId: 'uploadFolderId'
            };

        sessionManager.setPreferred = function (type) {
            localStorageService.cookie.set(KEYS.preferredView, type);
            return type;
        };

        sessionManager.getPreferred = function () {
            return localStorageService.cookie.get(KEYS.preferredView) || galleryTypes.LIST_VIEWTYPE;
        };

        sessionManager.setLastSearched = function (view) {
            localStorageService.cookie.set(KEYS.lastSearched, view);
        };

        sessionManager.getLastSearched = function () {
            return localStorageService.cookie.get(KEYS.lastSearched);
        };

        sessionManager.setLastDocumentType = function (type) {
            localStorageService.cookie.set(KEYS.lastDocumentType, type);
        };

        sessionManager.getLastDocumentType = function () {
            return localStorageService.cookie.get(KEYS.lastDocumentType);
        };

        sessionManager.setCurrentView = function (view) {
            lastVisited = [view];
        };

        sessionManager.updateHistory = function (ids) {
            lastVisited = ids;
        };

        sessionManager.clearHistory = function() {
            lastVisited = [];
        };

        sessionManager.getLastVisited = function () {
            // Persists this variable across this session.

            var view = lastVisited.pop();
            if (lastVisited.length === 0) {
                return viewTypes.SHARED_TYPE;
            }

            //TODO: Since search can only support files now If folders are supported in the future, we should update it.
            var type = [viewTypes.AWAITING_FEEDBACK_TYPE, viewTypes.OUT_FOR_REVIEW_TYPE, viewTypes.SEARCH_TYPE];

            if (type.indexOf(lastVisited[0]) !== -1) {
                return lastVisited[0];
            }
            return lastVisited[lastVisited.length - 1];

        };

        sessionManager.setReturningMobileVisitor = function () {
            localStorageService.cookie.set(KEYS.returningMobileVisitor, true);
        };

        sessionManager.getReturningMobileVisitor = function () {
            return localStorageService.cookie.get(KEYS.returningMobileVisitor);
        };

        sessionManager.setTimeZoneId = function (timeZoneId) {
            localStorageService.cookie.set(KEYS.timeZoneId, timeZoneId);
        };

        sessionManager.getTimeZoneId = function () {
            return localStorageService.cookie.get(KEYS.timeZoneId);
        };

        sessionManager.setRestoredFilesShown = function (b) {
            localStorageService.cookie.set(KEYS.restoredModal, b);
        };

        sessionManager.getRestoredFilesShown = function () {
            return localStorageService.cookie.get(KEYS.restoredModal);
        };

        sessionManager.getUploadFolderId = function () {
            return $window.sessionStorage.getItem(KEYS.uploadFolderId);
        };

        sessionManager.setUploadFolderId = function (value) {
            $window.sessionStorage.setItem(KEYS.uploadFolderId, value);
        };

        sessionManager.resetPaths = function () {
            localStorageService.cookie.remove(KEYS.path);
            localStorageService.cookie.remove(KEYS.uploadFolderId);
        };

        sessionManager.resetPath = function () {
            localStorageService.cookie.remove(KEYS.path);
        };

        sessionManager.getDeletedItems = function () {
            var items = localStorageService.cookie.get(KEYS.deletedItems);
            if (!items) {
                return {
                    documents: [],
                    folders: []
                };
            } else {
                return items;
            }
        };

        sessionManager.setDeletedItems = function (deletedDocumentIds, deletedFolderIds) {
            // Overwrites previously deleted items in cookie "undo function"
            localStorageService.cookie.set(KEYS.deletedItems, {
                documents: deletedDocumentIds,
                folders: deletedFolderIds
            });
        };

        sessionManager.addToDeletedItems = function (deletedDocumentIds, deletedFolderIds) {
            var deletedItems = sessionManager.getDeletedItems();
            localStorageService.cookie.set(KEYS.deletedItems, {
                documents: deletedItems.documents.concat(deletedDocumentIds),
                folders: deletedItems.folders.concat(deletedFolderIds)
            });
        };

        sessionManager.getRedirectState = function () {
            return localStorageService.cookie.get(KEYS.redirectState);
        };

        sessionManager.setRedirectState = function (value) {
            localStorageService.cookie.set(KEYS.redirectState, value);
        };

        sessionManager.resetRedirectState = function () {
            localStorageService.cookie.remove(KEYS.redirectState);
        };

        sessionManager.setPhotoUploadExpiration = function (data) {
            var photoUploadUrl = data && data.ProfilePhotoUploadUrl;
            if (photoUploadUrl) {
                //Extract the time by when the S3 Url is valid and store it in cookie
                var startIndex = photoUploadUrl.indexOf('Expires=') + 8,
                    endIndex = photoUploadUrl.indexOf('&', startIndex),
                    expiration;
                expiration = parseInt(photoUploadUrl.substring(startIndex, endIndex));
                localStorageService.cookie.set(KEYS.photoUploadUrlExpiration, expiration);
            }
        };

        sessionManager.getPhotoUploadExpiration = function () {
            return localStorageService.cookie.get(KEYS.photoUploadUrlExpiration);
        };

        sessionManager.logout = function () {
            localStorageService.cookie.clearAll();
        };

        return sessionManager;
    }

}());
